export default __webpack_public_path__ + "static/media/food.189725c8.svg";